import { Box, Grid, SxProps, Typography } from '@mui/material';
import * as React from 'react';
import { FunctionComponent } from 'react';
import AutomotiveDisplay from './AutomotiveDisplay';
import { GetResponsiveWidth } from '../common/TabsComponent';
import { ApplicationsAutomotiveContent } from '../../graphql/pimcore/modules/siteContent/types/ApplicationsContent';
import { InternalLinkSection } from '../common/internalLinkSection';

export const LayoutStyles: SxProps = {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: '1.5rem',
    paddingBottom: '1.5rem',
    flexDirection: 'column',
    overflowY: 'hidden',
    width: GetResponsiveWidth,
    alignItems: 'flex-start',
    margin: 'auto',
};

interface AutomotiveOverviewPageProps {
    cmsContent: ApplicationsAutomotiveContent;
}

const AutomotiveOverviewPage: FunctionComponent<AutomotiveOverviewPageProps> = ({ cmsContent }) => {
    const { temperatureSensorLinks } = cmsContent;
    const hasTemperatureSensorLinks = temperatureSensorLinks.links.length > 0;

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '0',
                    width: '100%',
                    boxSizing: 'border-box',
                    flexDirection: 'column',
                    overflowY: 'hidden',
                    backgroundColor: '#F2F2F2',
                }}
            >
                <Box sx={LayoutStyles}>
                    <Typography sx={{ fontFamily: 'Poppins', fontSize: '24px', fontWeight: 700 }}>
                        {cmsContent.overviewTitle.content}
                    </Typography>
                    <Typography
                        component="div"
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: '16px',
                            fontWeight: 400,
                            lineHeight: '24px',
                            marginTop: '1.5rem',
                            marginBottom: '2rem',
                        }}
                        dangerouslySetInnerHTML={{
                            __html: cmsContent.overviewMainText.content,
                        }}
                    ></Typography>
                </Box>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '0',
                    width: '100%',
                    boxSizing: 'border-box',
                    flexDirection: 'column',
                    overflowY: 'hidden',
                    backgroundColor: 'white',
                }}
            >
                <Box sx={LayoutStyles}>
                    <AutomotiveDisplay cmsContent={cmsContent} />
                </Box>
                {hasTemperatureSensorLinks ? (
                    <InternalLinkSection
                        section={temperatureSensorLinks}
                        contentPadding={{
                            width: GetResponsiveWidth,
                            margin: 'auto',
                            alignItems: 'flex-start',
                        }}
                    />
                ) : null}
                <Box sx={LayoutStyles}>
                    <Grid
                        container
                        spacing={2}
                        sx={{
                            marginTop: '3rem',
                            marginBottom: '4rem',
                        }}
                    >
                        {cmsContent.highlights.entries.map((entry, idx) => (
                            <Grid item xs={12} sm={4} key={idx}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        textAlign: 'center',
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontFamily: 'Poppins',
                                            fontSize: '20px',
                                            fontWeight: 700,
                                        }}
                                    >
                                        {entry.title}
                                    </Typography>
                                    <img
                                        src={entry.imageUrl}
                                        alt={entry.title}
                                        style={{
                                            width: '114px',
                                            height: '114px',
                                            marginTop: '2rem',
                                            marginBottom: '2rem',
                                        }}
                                    />
                                    <Typography
                                        component="div"
                                        sx={{
                                            fontFamily: 'Poppins',
                                            fontSize: '16px',
                                            fontWeight: 400,
                                            lineHeight: '24px',
                                            marginTop: '1rem',
                                        }}
                                        dangerouslySetInnerHTML={{ __html: entry.text }}
                                    ></Typography>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Box>
        </>
    );
};

export default AutomotiveOverviewPage;
